/**
 * Nhật ký thay đổi (Doc/11a "Lịch sử chỉnh sửa để truy trách nhiệm") — phần logic thuần, không
 * DOM, không gọi API, để kiểm được trong môi trường `node` của vitest.
 *
 * Nhãn trường và giá trị dạng mã (địa bàn, loại MM, cờ hoạt động) do máy chủ dịch sẵn, để màn
 * hình và file CSV nói cùng một chữ.
 */

/** `tone` là hậu tố class `status-*` của `.badge`. */
const METHODS = {
  direct: { label: 'Sửa trực tiếp', tone: 'submitted' },
  proposal: { label: 'Qua đề xuất', tone: 'approved' },
  proposal_rejected: { label: 'Đề xuất bị từ chối', tone: 'rejected' },
  field_create: { label: 'Tạo tại thực địa', tone: 'draft' },
  import: { label: 'Nhập file', tone: 'draft' },
};

/**
 * Lựa chọn của ô lọc. Chưa có `field_create` / `import`: phase 2 mới ghi hai cách này, chọn
 * chúng bây giờ chỉ ra danh sách rỗng và làm người xem tưởng dữ liệu bị thiếu.
 */
export const METHOD_FILTER = ['direct', 'proposal', 'proposal_rejected'].map((key) => [key, METHODS[key].label]);

export const FILTER_KEYS = ['entity', 'field', 'method', 'actorId', 'approverId', 'instanceId', 'from', 'to'];

export function methodInfo(method) {
  return METHODS[method] || { label: method, tone: 'draft' };
}

/** Giá trị rỗng phải hiện ra thành chữ, nếu không "sửa từ trống sang X" trông như mất dữ liệu. */
export function valueText(v) {
  if (v === null || v === undefined || v === '') return '(trống)';
  return typeof v === 'object' ? JSON.stringify(v) : String(v);
}

/** Bộ lọc trên URL → chỉ giữ khoá đã biết, bỏ ô trống. */
export function filtersFromParams(params = {}) {
  const out = {};
  for (const key of FILTER_KEYS) {
    if (params[key]) out[key] = params[key];
  }
  return out;
}

/**
 * Ô ngày trả 'YYYY-MM-DD'; máy chủ so theo thời điểm, nên nới hai đầu ra trọn ngày theo giờ máy
 * người xem. Không nới thì thay đổi buổi chiều của đúng ngày "đến" bị rơi khỏi kết quả.
 */
export function toApiQuery(filters) {
  const { from, to, ...rest } = filters;
  return {
    ...rest,
    from: from ? new Date(`${from}T00:00:00`).toISOString() : undefined,
    to: to ? new Date(`${to}T23:59:59.999`).toISOString() : undefined,
  };
}

/**
 * Vườn không có trang riêng: mở hồ sơ Hộ chứa nó. Trả đường dẫn; `null` nếu không xác định được, hoặc
 * hồ sơ đó đã xoá mềm (mở ra chỉ gặp "Không tìm thấy", trong khi việc xoá vẫn nằm ngay trên dòng này).
 */
export function recordPath(entry) {
  if (entry.profileActive === false) return null;
  if (entry.entity === 'middleman') return `/middlemen/${entry.entityId}`;
  const householdId = entry.entity === 'plot' ? entry.householdId : entry.entityId;
  return householdId ? `/households/${householdId}` : null;
}

export function gpsText(gps) {
  return gps ? `${gps.lat}, ${gps.lng}` : null;
}

/** Một dòng bảng cho mỗi trường; thay đổi không còn trường nào vẫn giữ một dòng, sự kiện không được mất. */
export function rowsOf(entry) {
  return entry.changes?.length ? entry.changes : [null];
}
